import React from 'react'
import LoginForm from '../../components/portal/LoginForm'
import RegisterForm from '../../components/portal/RegisterForm'
import { withRouter } from '../../utils/router'
import { isAuthenticated } from '../../utils/session'
import './index.css'

class Login extends React.Component {
    state = {
        showBox: 'login',   //展示当前表单
    }

    componentDidMount() {
        if (isAuthenticated()) {
            this.props.router.navigate(-1);    //当浏览器用后退按钮回到登录页时，判断登录页是否登录，是登录就重定向上个页面
        }
    }

    //切换showbox
    switchShowBox = (box) => {
        this.setState({
            showBox: box
        })
    }

    render() {
        const { showBox } = this.state
        document.title = "登录&注册 - 元纹";
        return (
            <div id='login-page' className='login-page'>
                <div>
                    <div id='backgroundBox' className='backgroundBox' />
                    <div className='container'>
                        <LoginForm
                            className={showBox === 'login' ? 'box showBox' : 'box hiddenBox'}
                            switchShowBox={this.switchShowBox} />
                        <RegisterForm
                            className={showBox === 'register' ? 'box showBox' : 'box hiddenBox'}
                            switchShowBox={this.switchShowBox} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Login)
